export default __webpack_public_path__ + "static/media/qr_request_sheet.55adb9b0.jpg";